import(/* webpackMode: "eager", webpackExports: ["AvatarMenu"] */ "/app/lib/AvatarMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DesktopUpdateBanner"] */ "/app/lib/DesktopUpdateBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeDashboard"] */ "/app/lib/HomeDashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JobutuLogo"] */ "/app/lib/JobutuLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SigninPill"] */ "/app/lib/SigninPill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SparkleBackground"] */ "/app/lib/SparkleBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeToggle"] */ "/app/lib/ThemeToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.2.8_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.99.0/node_modules/next/dist/client/app-dir/link.js");
